import { Modal } from "@frends/ui-components/react";
import type { ModalProps } from "@frends/ui-components/react/types/Modal";

export default Modal;
export type { ModalProps };
